export const settings_referral_en = {
  referral_rewards: "Referral Rewards",
  settings_referral_title: "Referral",
  settings_referral_desc:
    "Manage your referral rewards effortlessly from this page. Track your lifetime earnings, view available and withdrawn amounts, and see detailed referral activity. You can also review your withdrawal history and monitor users you've successfully referred.",
  history: "History",
  settings_referral_tabs_referred_users: "Referred users",

  settings_referral_tab_card_available: "Available to withdraw ",
  settings_referral_tab_card_lifetime: "Lifetime earnings",
  settings_referral_tab_card_tracked: "Tracked",
  settings_referral_tab_card_withdrawn: "Withdrawn",
  settings_referral_withdraw_amount_title: "Enter withdrawal amount",
  settings_referral_withdraw_amount_value_min:
    "Minimum cash-out amount: 0 credits | Minimum cash-out amount: 1 credit | Minimum cash-out amount: {count} credits",
  withdraw: "Withdraw",

  settings_referral_history_column_referral_source: "Referral source",
  settings_referral_history_column_referral_amount: "Amount earned",

  email_input_placeholder: "Add emails, separated by commas",

  settings_referral_tab_not_available_title: "Affiliate Program",
  settings_referral_tab_not_available_desc:
    "Earn cash rewards when you refer others. Register today to start tracking your earnings.",
  settings_referral_tab_not_available_button: "Register as Affiliate",

  approved: "Approved",
  rejected: "Rejected",

  setting_referral_withdraw_id: "Referral Withdrawal ID",
  settings_referral_id: "Referral ID",
};
export const settings_referral_zhCN = {
  referral_rewards: "推荐奖励",
  settings_referral_title: "推荐计划",
  settings_referral_desc:
    "在此页面轻松管理您的推荐奖励。追踪您的终身收益，查看可用和已提现金额，以及详细的推荐活动。您还可以查看提现历史记录并监控您成功推荐的用户。",
  history: "历史记录",
  settings_referral_tabs_referred_users: "已推荐用户",

  settings_referral_tab_card_available: "可提现金额",
  settings_referral_tab_card_lifetime: "终身收益",
  settings_referral_tab_card_tracked: "已追踪",
  settings_referral_tab_card_withdrawn: "已提现",
  settings_referral_withdraw_amount_title: "输入提现金额",
  settings_referral_withdraw_amount_value_min: "最低提现金额：500积分",
  withdraw: "提现",

  settings_referral_history_column_referral_source: "推荐来源",
  settings_referral_history_column_referral_amount: "获得金额",

  email_input_placeholder: "添加邮箱，用逗号分隔",

  settings_referral_tab_not_available_title: "联盟计划",
  settings_referral_tab_not_available_desc:
    "推荐他人即可赚取现金奖励。立即注册开始追踪您的收益。",
  settings_referral_tab_not_available_button: "注册成为联盟会员",
  approved: "已批准",
  rejected: "已拒绝",

  setting_referral_withdraw_id: "推荐提现ID",
  settings_referral_id: "推荐ID",
};

export const settings_referral_zhTW = {
  referral_rewards: "推薦獎勵",
  settings_referral_title: "推薦計劃",
  settings_referral_desc:
    "在此頁面輕鬆管理您的推薦獎勵。追蹤您的終身收益，查看可用和已提現金額，以及詳細的推薦活動。您還可以查看提現歷史記錄並監控您成功推薦的用戶。",
  history: "歷史記錄",
  settings_referral_tabs_referred_users: "已推薦用戶",

  settings_referral_tab_card_available: "可提現金額",
  settings_referral_tab_card_lifetime: "終身收益",
  settings_referral_tab_card_tracked: "已追蹤",
  settings_referral_tab_card_withdrawn: "已提現",
  settings_referral_withdraw_amount_title: "輸入提現金額",
  settings_referral_withdraw_amount_value_min: "最低提現金額：500點數",
  withdraw: "提現",

  settings_referral_history_column_referral_source: "推薦來源",
  settings_referral_history_column_referral_amount: "獲得金額",

  email_input_placeholder: "添加信箱，用逗號分隔",

  settings_referral_tab_not_available_title: "聯盟計畫",
  settings_referral_tab_not_available_desc:
    "推薦他人即可賺取現金獎勵。立即註冊開始追蹤您的收益。",
  settings_referral_tab_not_available_button: "註冊成為聯盟會員",
  approved: "已核准",
  rejected: "已拒絕",

  setting_referral_withdraw_id: "推薦提現ID",
  settings_referral_id: "推薦ID",
};

export const settings_referral_ja = {
  referral_rewards: "紹介報酬",
  settings_referral_title: "紹介プログラム",
  settings_referral_desc:
    "このページから紹介報酬を簡単に管理できます。生涯収益を追跡し、利用可能な金額と引き出した金額を表示し、詳細な紹介活動を確認できます。また、出金履歴を確認し、正常に紹介したユーザーを監視することもできます。",
  history: "履歴",
  settings_referral_tabs_referred_users: "紹介済みユーザー",

  settings_referral_tab_card_available: "引き出し可能金額",
  settings_referral_tab_card_lifetime: "生涯収益",
  settings_referral_tab_card_tracked: "追跡済み",
  settings_referral_tab_card_withdrawn: "引き出し済み",
  settings_referral_withdraw_amount_title: "引き出し金額を入力",
  settings_referral_withdraw_amount_value_min:
    "最低引き出し金額：500クレジット",
  withdraw: "引き出す",

  settings_referral_history_column_referral_source: "紹介元",
  settings_referral_history_column_referral_amount: "獲得金額",

  email_input_placeholder: "メールアドレスを追加（カンマ区切り）",

  settings_referral_tab_not_available_title: "アフィリエイトプログラム",
  settings_referral_tab_not_available_desc:
    "他の人を紹介して現金報酬を獲得しましょう。今すぐ登録して収益の追跡を開始してください。",
  settings_referral_tab_not_available_button: "アフィリエイトとして登録",
  approved: "承認済み",
  rejected: "拒否済み",

  setting_referral_withdraw_id: "紹介出金ID",
  settings_referral_id: "紹介ID",
};

export const settings_referral_ko = {
  referral_rewards: "추천 보상",
  settings_referral_title: "추천 프로그램",
  settings_referral_desc:
    "이 페이지에서 추천 보상을 쉽게 관리하세요. 평생 수익을 추적하고, 사용 가능한 금액과 인출된 금액을 확인하며, 상세한 추천 활동을 볼 수 있습니다. 또한 인출 내역을 검토하고 성공적으로 추천한 사용자를 모니터링할 수도 있습니다.",
  history: "내역",
  settings_referral_tabs_referred_users: "추천한 사용자",

  settings_referral_tab_card_available: "인출 가능 금액",
  settings_referral_tab_card_lifetime: "평생 수익",
  settings_referral_tab_card_tracked: "추적됨",
  settings_referral_tab_card_withdrawn: "인출됨",
  settings_referral_withdraw_amount_title: "인출 금액 입력",
  settings_referral_withdraw_amount_value_min: "최소 인출 금액: 500크레딧",
  withdraw: "인출",

  settings_referral_history_column_referral_source: "추천 출처",
  settings_referral_history_column_referral_amount: "획득 금액",

  email_input_placeholder: "이메일 추가 (쉼표로 구분)",
  settings_referral_tab_not_available_title: "제휴 프로그램",
  settings_referral_tab_not_available_desc:
    "다른 사람을 추천하고 현금 보상을 받으세요. 지금 등록하여 수익 추적을 시작하세요.",
  settings_referral_tab_not_available_button: "제휴사로 등록",
  approved: "승인됨",
  rejected: "거부됨",

  setting_referral_withdraw_id: "추천 출금 ID",
  settings_referral_id: "추천 ID",
};

export const settings_referral_hi = {
  referral_rewards: "रेफरल पुरस्कार",
  settings_referral_title: "रेफरल प्रोग्राम",
  settings_referral_desc:
    "इस पेज से आसानी से अपने रेफरल पुरस्कार प्रबंधित करें। अपनी आजीवन कमाई ट्रैक करें, उपलब्ध और निकाली गई राशि देखें, और विस्तृत रेफरल गतिविधि देखें। आप अपना निकासी इतिहास भी समीक्षा कर सकते हैं और सफलतापूर्वक रेफर किए गए उपयोगकर्ताओं की निगरानी कर सकते हैं。",
  history: "इतिहास",
  settings_referral_tabs_referred_users: "रेफर किए गए उपयोगकर्ता",

  settings_referral_tab_card_available: "निकासी के लिए उपलब्ध",
  settings_referral_tab_card_lifetime: "आजीवन कमाई",
  settings_referral_tab_card_tracked: "ट्रैक किया गया",
  settings_referral_tab_card_withdrawn: "निकाला गया",
  settings_referral_withdraw_amount_title: "निकासी राशि दर्ज करें",
  settings_referral_withdraw_amount_value_min: "न्यूनतम नकदी राशि: 500 क्रेडिट",
  withdraw: "निकासी",

  settings_referral_history_column_referral_source: "रेफरल स्रोत",
  settings_referral_history_column_referral_amount: "अर्जित राशि",

  email_input_placeholder: "ईमेल जोड़ें, अल्पविराम से अलग",

  settings_referral_tab_not_available_title: "एफिलिएट प्रोग्राम",
  settings_referral_tab_not_available_desc:
    "जब आप दूसरों को रेफर करते हैं तो नकद पुरस्कार कमाएं। अपनी कमाई ट्रैक करना शुरू करने के लिए आज ही पंजीकरण करें।",
  settings_referral_tab_not_available_button: "एफिलिएट के रूप में पंजीकरण करें",
  approved: "अनुमोदित",
  rejected: "अस्वीकृत",

  setting_referral_withdraw_id: "रेफरल निकासी आईडी",
  settings_referral_id: "रेफरल आईडी"
};
